var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"gamma"},[_vm._v(" Section "+_vm._s(_vm.section)+" of 30 ")])}
var staticRenderFns = []

export { render, staticRenderFns }